<template>
  <div>
    <div
      class="line hover_op"
      :class="{ active: show_drop }"
      @click="show_drop = !show_drop"
    >
      <div class="select" :title="selected_value">
        <span
          class="color"
          :style="{
            'background-color': waitingRoom
              ? waitingRoomBackground
              : roomBackground,
          }"
        ></span>
        {{ waitingRoom ? waitingRoomBackground : roomBackground }}
      </div>
      <img src="@/assets/img/drop_arrow.svg" alt="" class="arrow" />
    </div>

    <div class="drop" :class="{ active: show_drop }">
      <template v-for="option in options">
        <button
          class="hover_op"
          :key="option.id"
          :class="{ active: option.active }"
          @click="
            (show_drop = !show_drop),
              (option.active = true),
              (selected_value = option.label),
              setItem(option.id)
          "
        >
          <span
            class="color"
            :style="{ 'background-color': option.label }"
          ></span>
          {{ option.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropDownWithColor",

  data() {
    return {
      show_drop: false,
      selected_value: this.default_item,
    };
  },

  methods: {
    setItem(id) {
      this.$emit("setItem", id);
    },
  },

  props: {
    default_item: String,
    options: [Array, Object],
    waitingRoom: [Boolean, false],
  },

  computed: {
    waitingRoomBackground() {
      return this.$store.state.meeting.roomData.waitingRoomBackground;
    },
    roomBackground() {
      return this.$store.state.meeting.roomData.roomBackground;
    },
  },
};
</script>

<style scoped>
button {
  display: flex;
  align-items: center;
}

.color {
  margin-right: 16px;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  cursor: pointer;
  flex: none;
}
</style>